import { collection, collectionGroup, doc } from 'firebase/firestore';
import {
  gameInfoConverter,
  groupConverter,
  participantConverter,
  variationConverter,
} from './converters';
import { db } from './firestore';

export const gameInfoCol = collection(db, 'game-info').withConverter(
  gameInfoConverter
);

export const groupsCol = collection(db, 'groups').withConverter(groupConverter);

export const groupRef = (id: string) =>
  doc(db, 'groups', id).withConverter(groupConverter);

export const variationsColGroup = collectionGroup(
  db,
  'variations'
).withConverter(variationConverter);

export const variationsCol = (groupId: string) =>
  collection(db, 'groups', groupId, 'variations').withConverter(
    variationConverter
  );

export const participantsCol = collection(db, 'participants').withConverter(
  participantConverter
);

export const participantRef = (participantId: string) =>
  doc(db, 'participants', participantId).withConverter(participantConverter);
